import { connect } from "react-redux";
import NoMatch from "../components/NoMatch";

const mapStateToProps = ({ Misc }) => ({
    language: Misc.language.language,
    store: Misc.store.store,
    country: Misc.country.country
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(NoMatch);
